/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Dados do template de email
 */
export interface EmailTemplateResponse {
  /**
   * Indica se o template está ativo
   */
  active?: boolean;
  /**
   * Data de criação
   */
  createdAt?: Date;
  /**
   * Usuário que criou o template
   */
  createdBy?: string;
  /**
   * Data/hora da desativação
   */
  deactivatedAt?: Date;
  /**
   * Usuário que desativou o template
   */
  deactivatedBy?: string;
  /**
   * Descrição do template
   */
  description?: string;
  /**
   * ID do template
   */
  id?: number;
  /**
   * Assunto padrão do email
   */
  subject?: string;
  /**
   * Subtítulo do email
   */
  subtitle?: string;
  /**
   * ID do template no provedor
   */
  templateId?: string;
  /**
   * Nome único do template
   */
  templateName?: string;
  /**
   * Data da última atualização
   */
  updatedAt?: Date;
  /**
   * Usuário que atualizou o template
   */
  updatedBy?: string;
}
